<!--
 * @Author: your name
 * @Date: 2021-04-27 14:23:35
 * @LastEditTime: 2021-05-26 11:38:05
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /youhuaguo-ui/src/components/common/contractFramework.vue
-->
<template>
  <div>
    <el-dialog
      title="返点付款"
      :visible.sync="customListModal"
      width="1000px"
      class="yhg-dialog"
      :fullscreen="true"
      @open="openCustomSelectModal"
      @close="payInfoClose"
    >
      <el-form :inline="true" :model="customForm" class="demo-form-inline">
        <el-form-item label="收款方" prop="payAccount" class="block-form-item w-25">
          <el-input v-model="customForm.payAccount" size="small" placeholder="收款方" ></el-input>
        </el-form-item>
        <el-form-item label="收款账号" prop="payAccountNum" class="block-form-item w-25" >
          <el-input v-model="customForm.payAccountNum" size="small" placeholder="收款账号" ></el-input>
        </el-form-item>
        <el-form-item label="开户行" prop="depositBank" class="block-form-item w-25" >
          <el-input v-model="customForm.depositBank" size="small" placeholder="开户行" ></el-input>
        </el-form-item>
        <el-form-item label="总金额 " prop="totalPrice" class="block-form-item w-25" >
          <el-input v-model="customForm.totalPrice" size="small" placeholder="总金额" disabled></el-input>
        </el-form-item>
        <el-form-item label="付款事由" prop="payReason" class="block-form-item w-25">
          <el-input type="textarea" v-model="customForm.payReason" rows="1" show-word-limit placeholder="付款事由" maxlength="100"></el-input>
        </el-form-item>
        <el-form-item label="项目所属部门" prop="payDepart" class="block-form-item w-25">
            <el-select v-model="customForm.payDepart" clearable placeholder="未选择" class="w-100" >
              <el-option label="商务-上海" :value="1"></el-option>
              <el-option label="商务-北京" :value="2"></el-option>
              <el-option label="商务-大嫂" :value="3"></el-option>
              <el-option label="广州长尾" :value="4"></el-option>
            </el-select>
          </el-form-item>
      </el-form>
      <div class="select-con single">
        <span class="label">已选择的投放记录：</span>
      </div>
      <div class="table-con">
        <el-table
          :data="customTable"
          v-loading="customTableLoading"
          size="mini"
          ref="customSelectTable"
        >
          <el-table-column label="投放编号" min-width="120" prop="code" align="center">
            <template slot-scope="scope">
              <span style="color:red" v-if="scope.row.paymentStatus==1">{{ scope.row.code + "（审批中）"}}</span>
              <span style="color:red" v-else-if="scope.row.paymentStatus==2">{{ scope.row.code + "（审批通过）"}}</span>
              <span v-else-if="scope.row.paymentStatus==0">{{ scope.row.code}}</span>
            </template>
          </el-table-column>          <el-table-column label="博主名称" prop="bloggerName" min-width="160" align="center">
          </el-table-column>
          <el-table-column label="客户名称" prop="customerName" align="center"></el-table-column>
          <el-table-column label="品牌" prop="brandName" align="center"></el-table-column>
          <el-table-column label="发布日期" min-width="120" prop="publishTime" align="center">
            <template slot-scope="scope">
              {{ scope.row.publishTime && scope.row.publishTime.split(' ')[0] }}
            </template>
          </el-table-column>
          <el-table-column label="执行价" prop="executePrice" align="center">
            <template slot-scope="scope">
              {{ readableNum(scope.row.executePrice) }}
            </template>
          </el-table-column>
          <el-table-column prop="payRebatePrice" align="center" label="返点金额">
            <template slot-scope="scope">
              <div>{{scope.row.payRebatePrice == null?readableNum(scope.row.presetRebatePrice):readableNum(scope.row.payRebatePrice) }}</div>
            </template>
          </el-table-column>
          <el-table-column label="备注" prop="pointRemark" align="center"></el-table-column>
          <el-table-column label="操作" align="center" width="100" fixed="right">
          <template slot-scope="scope">
            <div>
              <el-button type="text" size="small" @click="deleteRecord(scope.row)">删除购物车</el-button>
            </div>
          </template>
        </el-table-column>
        </el-table>
      </div>
      <div class="submit-con">
        <el-button type="primary" size="small" @click="onConfirmChoose" :disabled="contractValue.submitLoading">确认</el-button>
      </div>
      <el-dialog title="选择供应商" :visible.sync="supplierListModal" width="1000px" class="yhg-dialog" @open="openSupplierSelectModal" append-to-body>
        <div class="select-con single">
          <span class="label">已选供应商：</span>
          <div class="content" v-if="selectSupplier">
            <el-tag class="select-tag" closable :type="selectSupplier.name" effect="dark" @close="onSupplierTagClose">
              <span class="select-tag-text">{{ selectSupplier.name }}</span>
            </el-tag>
          </div>
        </div>
        <div class="filter-con">
          <span class="label">供应商名称：</span>
          <el-input size="small" v-model="supplierForm.queryString" placeholder="供应商名称" @keyup.enter.native="onSupplierSearch"></el-input>
          <el-button class="search-btn" size="small" type="primary" @click="onSupplierSearch">搜索</el-button>
        </div>
        <div class="table-con">
          <el-table :data="supplierTable" v-loading="supplierTableLoading" size="mini" ref="supplierSelectTable">
            <el-table-column label="选择" width="55" align="center">
              <template slot-scope="scope">
                <span class="hide-label-radio">
                  <el-radio v-model="selectSupplierId" @change="onChangeSupplier" :label="scope.row.code"></el-radio>
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="code" align="center" label="商务供应商编号"></el-table-column>
            <el-table-column prop="name" align="center" label="商务供应商名称"></el-table-column>
            <el-table-column prop="supplierType" align="center" label="供应商类型">
              <template slot-scope="scope">
                <div>{{scope.row.supplierType == 1?"公司":scope.row.supplierType == 2?"个人":""}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="bankAccount" align="center" label="收款账号"></el-table-column>
          </el-table>
          <div class="pagination-wrap">
            <el-pagination background @size-change="supplierSizeChange" @current-change="supplierCurrentChange" :current-page.sync="supplierPage.pageNum" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="supplierPage.pageSize"
              layout="total, sizes, prev, pager, next, jumper" :total="supplierPage.total">
            </el-pagination>
          </div>
        </div>
        <div class="submit-con">
          <el-button type="primary" size="small" @click="onConfirmSupplierChoose">确认</el-button>
        </div>
      </el-dialog>
    </el-dialog>
  </div>
</template>

<script>
import { supplierBusinessList,subShopcar } from "@/api/pay/api";
import util from "@/util/util";
export default {
  props: {
    contractDialog: {
      type: Boolean,
      default: false
    },
    contractValue:{
    },
    multiSelectList:{

    },
    payerInfo:{

    },
    tableData:{

    },
  },
  data() {
    return {
      contactShow:true,
      customListModal:this._props.contractDialog,
      total: 0,
      customForm: {
        businessPrincipal:"",
        customerName:"",
        nameOrCode:"",
        pageSize: 50,
        pageNum: 1,
        payAccount:"",
        payAccountNum:"",
        depositBank:"",
        totalPrice:0 ,
        payReason:"",
        payDepart:"",
      },
      selectCustomId: null,
      selectCustom: null,
      customTable: [],
      customTableLoading: false,
      statusList:['','启动审批中','启动审批不通过','进行中','进行中(结案审批中)','进行中(结案审批不通过)','已结案','进行中(关闭审批中)','进行中(关闭审批不通过)','已关闭'],
      supplierListModal: false,
      supplierPage: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },
      supplierForm: {
        queryString: "",
      },
      selectSupplierId: null,
      selectSupplier: null,
      supplierTable: [],
      supplierTableLoading: false,
   };
  },
  watch:{
    contractDialog: {
      handler(newVal, oldVal) {
        this.customListModal = newVal;
        console.log("123456789")
        if(newVal){
          this.selectCustomId = this.contractValue.id
          this.selectCustom = this.contractValue
          // this.openCustomSelectModal()
          this.customTable = this.multiSelectList ;
          this.total = this.multiSelectList.size ;
        }
      },
      deep: true
    },

    
  },
  methods: {
    payInfoClose(){
      this.$emit('payInfoClose')
    },

    //保存确认调整项
    onConfirmChoose(){
      this.contractValue.submitLoading = true ;
      if(this.customForm.payAccount == ''){
			  this.$message.error('请先填写收款方');
        this.contractValue.submitLoading = false ;
			  return
		  }
      if(this.customForm.payAccountNum == ''){
			  this.$message.error('请先填写收款账号');
        this.contractValue.submitLoading = false ;
			  return
		  }
      if(this.customForm.payReason == ''){
			  this.$message.error('请先填写付款事由');
        this.contractValue.submitLoading = false ;
			  return
		  }
      if(this.customForm.payDepart == ''){
			  this.$message.error('请先选择项目所属部门');
        this.contractValue.submitLoading = false ;
			  return
		  }
      this.$emit('payInfoSave',this.customForm);
    },
    //资源选择变化
    onChangeCustom(val) {
      this.selectCustom = this.customTable.find((v) => v.id == val);
    },
    //资源标签删除
    onCustomTagClose() {
      this.selectCustom = null;
      this.selectCustomId = null;
    },
    //资源选择弹窗打开
    openCustomSelectModal() {
      // this.onCustomSearch();
      this.init() ;
      console.log("进入页面");
    },

    init(){
      console.log("========进入购物车=========");
      this.customTable = this.multiSelectList ;
      this.total = this.multiSelectList.size ;
      this.customForm.supplierId = '' ;
      this.customForm.payAccount = this.payerInfo.payAccount ;
      this.customForm.payAccountNum = this.payerInfo.payAccountNum ;
      this.customForm.depositBank = this.payerInfo.depositBank+"123" ;
      this.customForm.payReason = '' ;
      this.customForm.payDepart = '' ;
      console.log("========进入购物车houmian=========");
      console.log("this.customTable",this.customTable);
      this.customForm.totalPrice = 0 ;
      this.multiSelectList.forEach((item, index) => {
        if(item.payRebatePrice!=null){
          this.customForm.totalPrice = this.customForm.totalPrice + item.payRebatePrice ;
        }else{
          this.customForm.totalPrice = this.customForm.totalPrice + item.presetRebatePrice ;  
        }
        
      })
    },
    /**
     * 数字可读化
     * @param num 数字
     */
    readableNum(num) {
      if (!num && num !== 0) return "";
      return util.priceFormat(num);
    },

    deleteRecord(obj){

      obj.payType = 3 ;
      subShopcar(obj).then(res=>{
        if(res.code === 1){
          this.$message({
            message: '删除购物车成功!',
            type: 'success'
          });
          var index = this.multiSelectList.findIndex(item => {
          if ( item.id == obj.id) {
              return true;
          }
          })
          this.multiSelectList.splice(index,1);

          var index2 = this.tableData.findIndex(item => {
            if ( item.id == obj.id) {
                return true;
            }
          });
          this.tableData[index2].isShopCar = "" ;
          this.customForm.totalPrice = 0 ;
          this.multiSelectList.forEach((item, index) => {
            if(item.payRebatePrice!=null){
              this.customForm.totalPrice = this.customForm.totalPrice + item.payRebatePrice ;
            }else{
              this.customForm.totalPrice = this.customForm.totalPrice + item.presetRebatePrice ;  
            }
          })
        }
      })

      // var index = this.multiSelectList.findIndex(item => {
      //     if ( item.id == obj.id) {
      //         return true;
      //         }
      //   })
      // this.multiSelectList.splice(index,1);

      // var index2 = this.tableData.findIndex(item => {
      //   if ( item.id == obj.id) {
      //       return true;
      //   }
      // });
      // this.tableData[index2].isShopCar = "" ;
      // this.customForm.totalPrice = 0 ;
      // this.multiSelectList.forEach((item, index) => {
      //   if(item.payRebatePrice!=null){
      //     this.customForm.totalPrice = this.customForm.totalPrice + item.payRebatePrice ;
      //   }else{
      //     this.customForm.totalPrice = this.customForm.totalPrice + item.presetRebatePrice ;  
      //   }
      // })

    },
    //打开资源选择弹窗
    onOpenSupplierSelectModal() {
      this.supplierListModal = true;
    },
    //资源选择弹窗打开
    openSupplierSelectModal() {
      if (this.customForm.payAccount) {
        console.log("dakaitanchuang")
        this.selectSupplier = {
          supplierId: this.customForm.supplierId,
          name: this.customForm.payAccount,
          bankAccount: this.customForm.payAccountNum,
          depositBank : this.customForm.depositBank ,
        };
        this.selectSupplierId = this.selectSupplier.supplierId;
      } else {
        this.selectSupplier = null;
        this.selectSupplierId = null;
      }
      this.supplierForm.queryString = "";
      this.onSupplierSearch();
    },

    //资源选择变化
    onChangeSupplier(val) {
      this.selectSupplier = this.supplierTable.find((v) => v.code == val);
    },
    //资源标签删除
    onSupplierTagClose() {
      this.selectSupplier = null;
      this.selectSupplierId = null;
    },
    //资源弹窗关闭
    onConfirmSupplierChoose() {
      if (this.selectSupplier) {
        this.customForm.payAccount = this.selectSupplier.name;
        this.customForm.supplierId = this.selectSupplier.supplierId;
        this.customForm.payAccountNum = this.selectSupplier.bankAccount;
        this.customForm.depositBank = this.selectSupplier.depositBank;
      } else {
        this.customForm.payAccount = "";
        this.customForm.supplierId = null;
        this.customForm.payAccountNum = "" ;
        this.customForm.depositBank = "" ;
      }
      this.supplierListModal = false;
    },
    /**
     * 监听分页器每页显示的条数变化
     * @param val 条数
     */
    supplierSizeChange(val) {
      this.supplierPage.pageNum = 1;
      this.supplierPage.pageSize = val;
      this.getSupplierList();
    },
    /**
     * 监听页数变化
     * @param val 当前页数
     */
    supplierCurrentChange(val) {
      this.supplierPage.pageNum = val;
      this.getSupplierList();
    },
    //资源搜索
    onSupplierSearch() {
      this.supplierPage.pageNum = 1;
      this.getSupplierList();
    },
    //获取资源列表
    getSupplierList() {
      let obj = {
        pageSize: this.supplierPage.pageSize,
        pageNum: this.supplierPage.pageNum,
      };
      if (this.supplierForm.queryString && this.supplierForm.queryString.trim()) {
        obj.nameOrCode = this.supplierForm.queryString.trim();
      }
      this.supplierTableLoading = true;
      supplierBusinessList(obj)
        .then((res) => {
          this.supplierTable = res.data || [];
          this.supplierPage.total = res.total;
          this.supplierTableLoading = false;
        })
        .catch((err) => {
          this.supplierTable = [];
          this.supplierPage.total = 0;
          this.supplierTableLoading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.table-con{
    height: 270px;
    overflow: auto;
}
.yhg-dialog {
  .select-con {
    display: flex;
    .label {
      white-space: nowrap;
    }
    .select-tag {
      margin-right: 5px;
      margin-bottom: 5px;
    }
    .select-tag-text {
      display: inline-block;
      max-width: 86px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .filter-con {
    display: flex;
    align-items: center;
    margin: 20px 0;
    width: 800px;
    .label {
      white-space: nowrap;
    }
    .search-btn {
      margin-left: 15px;
    }
  }
  .submit-con {
    margin-top: 20px;
    text-align: right;
  }
}
</style>
